import { AsyncPipe, DatePipe, Location, NgClass } from '@angular/common';
import { Component, inject, input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatError, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ActivatedRoute } from '@angular/router';

import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { UserNamePipe } from 'src/app/pipes/user-name.pipe';
import { AzureIdStatusPipe } from 'src/app/pipes/azure-id-status.pipe';

import { editorConfig } from '../../../models/editorconfig';
import { Recommendation } from '../../../models/recommendation/recommendation';
import { AccessService } from '../../../services/access.service';
import { EditorComponent } from '../../editor/editor.component';
import { ProlongationDecisionComponent } from '../../prolongation-decision/prolongation-decision.component';
import { SettleDialogComponent } from '../../settle-dialog/settle-dialog.component';
@Component({
  selector: 'app-recommendation-assessors-processing',
  templateUrl: './recommendation-assessors-processing.component.html',
  styleUrls: ['./recommendation-assessors-processing.component.scss'],
  imports: [
    EditorComponent,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    NgClass,
    MatError,
    MatButtonModule,
    AsyncPipe,
    UserNamePipe,
    AzureIdStatusPipe,
    MatCheckboxModule,
    MatDatepickerModule,
    MatSelectModule,
    MatOptionModule
  ]
})
export class RecommendationAssessorsProcessingComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private location = inject(Location);
  readonly accessService = inject(AccessService);
  readonly recommendations = input<Recommendation>();
  readonly form = input.required<UntypedFormGroup>();
  readonly auditorEditable = input<boolean>();
  readonly assessmentEditable = input<boolean>();
  dialog = inject(MatDialog);

  shortRemarkEditor = ClassicEditor;
  plantCommentsEditor = ClassicEditor;
  executionCommentEditor = ClassicEditor;
  currentTab = 0;
  datePipe = new DatePipe('en_EU');
  fileLinkId!: string;
  editorConfig = {};
  editorConfigClean = {};
  error!: string;
  options!: UntypedFormControl;
  array_mod_actions!: string[];
  array_mod_dates!: string[];
  array_mod_statuses!: string[];
  isNewRecommendation = false;
  prolongation_text = '';
  overdue = 'normal';

  ngOnInit() {
    if (this.route.snapshot.params?.audit) {
      this.isNewRecommendation = true;
    }
    this.currentTab = this.route.snapshot.params?.tab;
    this.editorConfig = editorConfig.standard;
    this.editorConfigClean = editorConfig.clean;
    this.isOverdue();
  }

  goBack() {
    this.location.back();
  }

  isProlongationStatus(prolongationStatus: string) {
    return this.form().get('prolongationStatus')?.value === prolongationStatus;
  }

  isOverdue(): void {
    const deadlineDate = this.form().get('currentDeadlineDate')?.value;
    if (deadlineDate) {
      const today = new Date();
      const deadline = new Date(deadlineDate);
      if (deadline < today) {
        this.overdue = 'red';
      }
    }
  }

  isNew(): boolean {
    return this.isNewRecommendation;
  }

  isGPIA(): boolean {
    const recommendations = this.recommendations();
    if (recommendations) {
      return recommendations.auditDefinition.includes('GPIA');
    } else {
      return false;
    }
  }

  isStatus(status: string): boolean {
    const recommendations = this.recommendations();
    if (recommendations) {
      return recommendations.status === status;
    } else {
      return false;
    }
  }

  isAuditor(auditor: string) {
    return this.recommendations()?.auditor === auditor;
  }

  checkDecision(decision: string) {
    return this.form().value.prolongationDecision === decision;
  }

  openDialog() {
    this.dialog.open(SettleDialogComponent, {
      data: {
        formGroup: this.form(),
        recommendations: this.recommendations()
      }
    });
  }

  validation(): boolean {
    return this.form().valid;
  }

  openDialogProlo() {
    this.dialog.open(ProlongationDecisionComponent, {
      data: {
        formGroup: this.form()
      }
    });
  }
}
